/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wsc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In what order are the cleanups applied?`)
};

const es_wsc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿En qué orden se aplican las limpiezas?`)
};

const de_wsc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In welcher Reihenfolge werden die Bereinigungen angewendet?`)
};

const nl_wsc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In welke volgorde worden de opruimingen toegepast?`)
};

const fr_wsc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dans quel ordre les nettoyages sont-ils appliqués ?`)
};

const it_wsc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In che ordine vengono applicate le pulizie?`)
};

const pt_br2_wsc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em que ordem as limpezas são aplicadas?`)
};

const pt_wsc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em que ordem as limpezas são aplicadas?`)
};

const ja_wsc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリーニングはどの順序で適用されますか？`)
};

const zh_wsc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这些清理操作的执行顺序是怎样的？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wsc_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wsc_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wsc_faq4_q", locale)
	if (locale === "en") return en_wsc_faq4_q(inputs)
	if (locale === "es") return es_wsc_faq4_q(inputs)
	if (locale === "de") return de_wsc_faq4_q(inputs)
	if (locale === "nl") return nl_wsc_faq4_q(inputs)
	if (locale === "fr") return fr_wsc_faq4_q(inputs)
	if (locale === "it") return it_wsc_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_wsc_faq4_q(inputs)
	if (locale === "pt") return pt_wsc_faq4_q(inputs)
	if (locale === "ja") return ja_wsc_faq4_q(inputs)
	return zh_wsc_faq4_q(inputs)
};